import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WEBLINKS_FEATURE_KEY, WeblinksState } from './weblinks.reducer';

export const selectWeblinksState = createFeatureSelector<WeblinksState>(WEBLINKS_FEATURE_KEY);

export const selectWeblinksLoaded = createSelector(selectWeblinksState, (state: WeblinksState) => state.loaded);

export const selectWeblinksError = createSelector(selectWeblinksState, (state: WeblinksState) => state.error);

export const selectAllWeblinks = createSelector(selectWeblinksState, (state: WeblinksState) => state.weblinks);
